/**
 * Convert string into spinal case.
 * Join punctuation with hyphen.
 * @memberof module:stringcase/lib
 * @function spinalcase
 * @param {string} str - String to convert.
 * @returns {string} Spinal cased string.
 */
'use strict';

var snakecase = require('./snakecase');
/** @lends spinalcase */


function spinalcase(str) {
  return snakecase(str).replace(/_/g, '-');
}

module.exports = spinalcase;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNwaW5hbGNhc2UuanMiXSwibmFtZXMiOlsic25ha2VjYXNlIiwicmVxdWlyZSIsInNwaW5hbGNhc2UiLCJzdHIiLCJyZXBsYWNlIiwibW9kdWxlIiwiZXhwb3J0cyJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7O0FBU0E7O0FBRUEsSUFBTUEsU0FBUyxHQUFHQyxPQUFPLENBQUMsYUFBRCxDQUF6QjtBQUVBOzs7QUFDQSxTQUFTQyxVQUFULENBQXFCQyxHQUFyQixFQUEwQjtBQUN4QixTQUFPSCxTQUFTLENBQUNHLEdBQUQsQ0FBVCxDQUFlQyxPQUFmLENBQXVCLElBQXZCLEVBQTZCLEdBQTdCLENBQVA7QUFDRDs7QUFFREMsTUFBTSxDQUFDQyxPQUFQLEdBQWlCSixVQUFqQiIsInNvdXJjZVJvb3QiOiIuLi8uLi9saWIiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIENvbnZlcnQgc3RyaW5nIGludG8gc3BpbmFsIGNhc2UuXG4gKiBKb2luIHB1bmN0dWF0aW9uIHdpdGggaHlwaGVuLlxuICogQG1lbWJlcm9mIG1vZHVsZTpzdHJpbmdjYXNlL2xpYlxuICogQGZ1bmN0aW9uIHNwaW5hbGNhc2VcbiAqIEBwYXJhbSB7c3RyaW5nfSBzdHIgLSBTdHJpbmcgdG8gY29udmVydC5cbiAqIEByZXR1cm5zIHtzdHJpbmd9IFNwaW5hbCBjYXNlZCBzdHJpbmcuXG4gKi9cblxuJ3VzZSBzdHJpY3QnXG5cbmNvbnN0IHNuYWtlY2FzZSA9IHJlcXVpcmUoJy4vc25ha2VjYXNlJylcblxuLyoqIEBsZW5kcyBzcGluYWxjYXNlICovXG5mdW5jdGlvbiBzcGluYWxjYXNlIChzdHIpIHtcbiAgcmV0dXJuIHNuYWtlY2FzZShzdHIpLnJlcGxhY2UoL18vZywgJy0nKVxufVxuXG5tb2R1bGUuZXhwb3J0cyA9IHNwaW5hbGNhc2U7XG4iXX0=